import React from 'react';

// Main App component
const App = () => {
  return (
    <div className="min-h-screen bg-[#121212] font-sans text-gray-100 p-4 sm:p-6 lg:p-8 flex items-center justify-center">
      <div className="max-w-6xl w-full bg-[#E3DDDD] rounded-3xl shadow-2xl overflow-hidden md:flex">
        {/* Left Section: Content */}
        <div className="p-6 sm:p-10 md:p-12 flex-1 flex flex-col justify-center text-center md:text-left">
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-black mb-4 leading-tight">
            Tax-Ready Finances.<br className="hidden sm:inline"/> Zero Hassle.
          </h1>
          
          <p className="text-lg sm:text-xl text-black mb-4 max-w-xl mx-auto md:mx-0">
            Snap receipts, track miles, sync to QuickBooks instantly. Recio makes expense tracking effortless for busy professionals.
          </p>

          {/* Star Rating */}
          <div className="flex items-center justify-center md:justify-start gap-2 mb-0">
            <div className="flex gap-1">
              <span className="text-yellow-500 text-2xl">★</span>
              <span className="text-yellow-500 text-2xl">★</span>
              <span className="text-yellow-500 text-2xl">★</span>
              <span className="text-yellow-500 text-2xl">★</span>
              <span className="text-yellow-500 text-2xl">★</span>
            </div>
          </div>

                   {/* CTA - Download Button */}
        <div className="flex justify-center md:justify-start">
  <a
    href="https://apps.apple.com/us/app/recio-receipt-scanner-log/id6751236159"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src="/app_store.svg" alt="App Store Icon" className="w-60 h-44 mr-0 md:mr-4" />
  </a>
</div>

          {/* Key Benefits */}
          <div className="space-y-3 mb-6 max-w-xl mx-auto md:mx-0 text-left">
            <div className="flex items-start gap-3">
              <span className="text-2xl">📸</span>
              <div>
                <h3 className="font-bold text-black">99% Accurate AI Scanning</h3>
                <p className="text-gray-700 text-sm">Snap receipts and extract all details automatically</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <span className="text-2xl">📍</span>
              <div>
                <h3 className="font-bold text-black">GPS Mileage Tracking</h3>
                <p className="text-gray-700 text-sm">IRS-compliant mile logs tracked automatically</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <span className="text-2xl">⚡</span>
              <div>
                <h3 className="font-bold text-black">QuickBooks Integration</h3>
                <p className="text-gray-700 text-sm">Expenses sync directly—no double entry</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <span className="text-2xl">✅</span>
              <div>
                <h3 className="font-bold text-black">Audit-Ready Reports</h3>
                <p className="text-gray-700 text-sm">Generate tax-compliant reports in seconds</p>
              </div>
            </div>
          </div>

          {/* Perfect For */}
          <div className="bg-white/30 rounded-xl p-4 mb-6 max-w-xl mx-auto md:mx-0">
            <p className="text-black text-sm">
              <span className="font-bold">Perfect for:</span> Freelancers • Small Business Owners • Real Estate Agents • Consultants
            </p>
          </div>


          {/* Support */}
          <div className="text-center md:text-left">
            <h2 className="text-black mb-2 font-bold text-lg">Need help?</h2>
        <p>
  <a
    href="mailto:hello@recio.app"
    style={{ color: '#4399bb', fontWeight: 'bold' }}
  >
    Email us
  </a>
</p>

          </div>

        </div>

        {/* Right Section: Device Mockup */}
        <div className="md:w-1/2 flex items-start justify-center p-6 sm:p-8 md:p-12 bg-[#000000] rounded-b-3xl md:rounded-r-3xl md:rounded-bl-none">
          <div className="relative w-64 h-auto aspect-[9/19] bg-black rounded-3xl shadow-2xl overflow-hidden border-8 border-gray-900">
            {/* Device screen */}
            <div className="absolute inset-0 m-1 bg-white rounded-2xl flex items-center justify-center overflow-hidden">
              <img
                src="/device_mockup.png"
                alt="Recio App Screenshot"
                className="w-full h-full object-cover"
                onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/300x600/1F425E/ffffff?text=Image+Load+Error"; }}
              />
            </div>
            {/* Speaker cutout (top) */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-16 h-2 bg-black rounded-b-md"></div>
            {/* Home button/fingerprint sensor (bottom, if applicable) */}
            <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-10 h-1.5 bg-black rounded-full"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
